export const environment = {
  production: false,
  baseUrl: 'https://api.tecnologiaasap.com.br',
  apiUrl: 'https://api.tecnologiaasap.com.br',
  firebase: {
    apiKey: 'AIzaSyCnQ7hg9qn8mrS3zSLX-xeXX3wKbuC2GXA',
    authDomain: 'admin-17e4f.firebaseapp.com',
    databaseURL: 'https://admin-17e4f.firebaseio.com',
    projectId: 'admin-17e4f',
    storageBucket: 'admin-17e4f.appspot.com',
    messagingSenderId: '572223664609'
  },
};
